/*
  ONF-CUSTOM-START :: alpha_cookie-banner.js

  Shopifys Einwilligungs-Banner kompakt machen.

  Warum alles hier und keine CSS-Datei mehr:
  Zwei Anlaeufe ueber ein Stylesheet blieben wirkungslos - erst ohne, dann
  mit !important. Der Banner kommt von Shopify, wird nachtraeglich
  eingefuegt, bringt eigene Stile mit und kann in einem Shadow DOM liegen.
  Gegen diese Kombination gewinnt eine Datei von aussen nicht zuverlaessig.
  Inline am Element gesetzte Werte mit Prioritaet schon - die stehen in der
  Kaskade ueber allem ausser dem gleichen Mittel.

  Die Elemente werden ausserdem nicht nur ueber Shopifys Klassennamen
  gesucht, sondern ersatzweise ueber den Beschriftungstext. Aendert Shopify
  die Klassen, greift es weiterhin.

  Rechtliches:
  - Der Erklaertext wird eingeklappt, nicht entfernt. Er ist mit einem Klick
    auf derselben Ebene lesbar, bevor irgendetwas zugestimmt wird.
  - Die Ueberschrift bleibt sichtbar, nur kleiner gesetzt.
  - Zustimmen und Ablehnen sind gleich gross und gleich stark. Die
    Orientierungshilfe der Aufsichtsbehoerden verlangt gleichwertige
    Schaltflaechen; ein gefuellter Zustimmen-Knopf neben einem
    zurueckhaltenden ist das Muster, das beanstandet wird. Umschalten ueber
    ACCENT_ACCEPT weiter unten.

  Mobil und Desktop:
  Die Werte in enhance() sind das Mobil-Layout und gelten auf jeder Breite.
  Ab DESKTOP_QUERY kommen fuer einzelne Elemente Abweichungen dazu: Text
  links, Knoepfe rechts in einer Reihe. Wechselt die Breite zurueck, werden
  genau die Mobil-Werte wiederhergestellt und reine Desktop-Werte entfernt -
  das Handy-Layout bleibt dadurch unveraendert.
*/
(function () {
  'use strict';

  /* Auf true setzen fuer einen schwarz gefuellten Zustimmen-Knopf.
     Optisch staerker, rechtlich das kritisierte Muster. */
  var ACCENT_ACCEPT = false;

  var CLAMP_LINES = 3;
  var MAX_WAIT_MS = 15000;
  var BLACK = '#121212';
  var WHITE = '#ffffff';
  var DESKTOP_QUERY = '(min-width: 990px)';

  function css(el, styles) {
    if (!el) return;
    Object.keys(styles).forEach(function (prop) {
      el.style.setProperty(prop, styles[prop], 'important');
    });
  }

  // Elemente mit eigenem Desktop-Layout. mobile = was ohnehin gesetzt wird,
  // desktop = nur die Abweichungen davon.
  var layout = [];

  function register(el, mobile, desktop) {
    if (!el) return;
    css(el, mobile);
    layout.push({ el: el, mobile: mobile, desktop: desktop });
  }

  function applyLayout(isDesktop) {
    layout.forEach(function (item) {
      if (isDesktop) {
        css(item.el, item.desktop);
        return;
      }
      Object.keys(item.desktop).forEach(function (prop) {
        if (Object.prototype.hasOwnProperty.call(item.mobile, prop)) {
          item.el.style.setProperty(prop, item.mobile[prop], 'important');
        } else {
          item.el.style.removeProperty(prop);
        }
      });
    });
  }

  function findBanner() {
    var direct = document.querySelector('#shopify-pc__banner');
    if (direct) return direct;
    // Kein Treffer im normalen DOM: einmalig die Shadow Roots durchsehen.
    var all = document.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var root = all[i].shadowRoot;
      if (root) {
        var inner = root.querySelector('#shopify-pc__banner');
        if (inner) return inner;
      }
    }
    return null;
  }

  // Knopf erst ueber die Klasse suchen, sonst ueber den Text. Shopify kann
  // die Klassen aendern, die Beschriftung bleibt.
  function pickButton(buttons, classPart, pattern) {
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].className.indexOf(classPart) !== -1) return buttons[i];
    }
    for (var j = 0; j < buttons.length; j++) {
      if (pattern.test(buttons[j].textContent.trim())) return buttons[j];
    }
    return null;
  }

  function styleButton(el, filled) {
    register(el, {
      flex: '1 1 0',
      'min-width': '0',
      width: 'auto',
      margin: '0',
      padding: '0 9px',
      'min-height': '30px',
      height: '30px',
      border: '1px solid ' + BLACK,
      'border-radius': '0',
      background: filled ? BLACK : WHITE,
      color: filled ? WHITE : BLACK,
      'font-size': '11.5px',
      'font-weight': '600',
      'line-height': '1.1',
      'letter-spacing': '0.01em',
      'text-transform': 'none',
      'white-space': 'nowrap'
    }, {
      // Auf dem Desktop nicht mehr halbe Breite, sondern feste Knopfgroesse.
      flex: '0 0 auto',
      'min-width': '150px',
      padding: '0 22px',
      'min-height': '38px',
      height: '38px',
      'font-size': '13px'
    });
  }

  function addReadMore(body) {
    if (!body || body.dataset.alphaCcDone) return;
    body.dataset.alphaCcDone = '1';

    var clamp = {
      display: '-webkit-box',
      '-webkit-line-clamp': String(CLAMP_LINES),
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden'
    };
    css(body, clamp);

    // Nur umschaltbar machen, wenn wirklich etwas abgeschnitten ist - sonst
    // stuende dort ein Knopf ohne Inhalt dahinter.
    if (body.scrollHeight <= body.clientHeight + 2) {
      css(body, { display: 'block', overflow: 'visible' });
      return;
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.textContent = 'Mehr lesen';
    button.setAttribute('aria-expanded', 'false');
    css(button, {
      display: 'inline-block',
      margin: '2px 0 0',
      padding: '0',
      border: '0',
      background: 'none',
      color: 'inherit',
      font: 'inherit',
      'font-size': '10.5px',
      'font-weight': '600',
      'text-decoration': 'underline',
      cursor: 'pointer'
    });

    var open = false;
    button.addEventListener('click', function () {
      open = !open;
      if (open) {
        css(body, { display: 'block', overflow: 'visible' });
      } else {
        css(body, clamp);
      }
      button.textContent = open ? 'Weniger' : 'Mehr lesen';
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    body.parentNode.insertBefore(button, body.nextSibling);
  }

  function enhance(banner) {
    if (banner.dataset.alphaCc) return;
    banner.dataset.alphaCc = '1';

    var dialog = banner.querySelector('.shopify-pc__banner__dialog') || banner.firstElementChild || banner;
    register(dialog, {
      padding: '8px 10px',
      'border-radius': '0',
      'max-width': '620px'
    }, {
      // Volle Breite, Text und Knoepfe nebeneinander. Shopify selbst schaltet
      // erst ab 1280px auf eine Reihe um und gibt den Knoepfen dann 580px
      // Mindestbreite - zusammen mit den 620px von oben blieb fuer den Text
      // kaum Platz. Deshalb hier ausdruecklich.
      'max-width': 'none',
      'flex-direction': 'row',
      'align-items': 'center',
      'justify-content': 'space-between',
      gap: '40px'
    });

    // Textblock (Ueberschrift, Text, "Mehr lesen") als linke Spalte.
    // width: auto ist noetig, weil Shopify unter 1280px Text UND Knopfreihe
    // auf width: 100% setzt - die Knopfreihe verdraengte den Text sonst auf
    // null Breite.
    register(banner.querySelector('.shopify-pc__banner__body'), {}, {
      flex: '1 1 0',
      width: 'auto',
      'min-width': '0',
      'max-width': '860px',
      margin: '0'
    });

    var title = banner.querySelector('.shopify-pc__banner__dialog-title') || banner.querySelector('h1, h2, h3');
    css(title, {
      margin: '0 0 2px',
      padding: '0',
      'font-size': '12px',
      'font-weight': '700',
      'line-height': '1.25'
    });

    var body = banner.querySelector('.shopify-pc__banner__dialog-body');
    if (!body) {
      var paragraphs = Array.prototype.slice.call(banner.querySelectorAll('p'));
      paragraphs.sort(function (a, b) { return b.textContent.length - a.textContent.length; });
      body = paragraphs[0];
    }
    css(body, { margin: '0', 'font-size': '11px', 'line-height': '1.3' });

    var buttons = Array.prototype.slice.call(banner.querySelectorAll('button'));
    var accept = pickButton(buttons, 'accept', /akzept|accept|zustimm|alle erlauben/i);
    var decline = pickButton(buttons, 'decline', /ablehn|decline|reject|verweiger/i);
    var prefs = pickButton(buttons, 'manage', /einstell|verwalt|preferen|manage/i);

    // Der gemeinsame Elternknoten der Knoepfe wird die Reihe. Damit ist es
    // egal, wie Shopify den Container nennt.
    var row = (accept && accept.parentNode) || (decline && decline.parentNode);
    register(row, {
      display: 'flex',
      'flex-wrap': 'wrap',
      gap: '5px',
      margin: '6px 0 0',
      padding: '0'
    }, {
      // Rechte Spalte: eine Reihe, rechtsbuendig, nur so breit wie noetig.
      flex: '0 0 auto',
      width: 'auto',
      'flex-direction': 'row',
      'flex-wrap': 'nowrap',
      'align-items': 'center',
      'justify-content': 'flex-end',
      'min-width': '0',
      gap: '8px',
      margin: '0'
    });

    if (decline) styleButton(decline, false);
    if (accept) styleButton(accept, ACCENT_ACCEPT);

    // "Einstellungen" ist keine Einwilligungsentscheidung, sondern ein
    // Zwischenschritt - als Textlink in eigener Zeile, damit die beiden
    // Hauptknoepfe wirklich nebeneinander stehen.
    register(prefs, {
      flex: '1 1 100%',
      order: '3',
      margin: '1px 0 0',
      padding: '0',
      'min-height': '0',
      height: 'auto',
      border: '0',
      background: 'none',
      color: 'inherit',
      'font-size': '10.5px',
      'font-weight': '500',
      'text-decoration': 'underline',
      'text-align': 'left'
    }, {
      // Desktop: als Textlink links vor den beiden Knoepfen in derselben Reihe.
      flex: '0 0 auto',
      order: '0',
      margin: '0 14px 0 0',
      'font-size': '12px',
      'white-space': 'nowrap'
    });

    // Layout vor "Mehr lesen" anwenden: ob der Text abgeschnitten ist, haengt
    // von der Spaltenbreite ab und wird dort gemessen.
    var mq = window.matchMedia(DESKTOP_QUERY);
    applyLayout(mq.matches);
    var onChange = function (e) { applyLayout(e.matches); };
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }

    addReadMore(body);
  }

  var started = Date.now();

  function tick() {
    var banner = findBanner();
    if (banner) {
      enhance(banner);
      return;
    }
    // Shopify fuegt den Banner erst nach dem Laden ein, der Zeitpunkt ist
    // nicht vorhersagbar. Nach 15s aufgeben statt dauerhaft zu suchen.
    if (Date.now() - started < MAX_WAIT_MS) {
      setTimeout(tick, 250);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
})();
/* ONF-CUSTOM-END */
